export default {
  container: {
    pointerEvents: ({ isActive }) => (isActive ? "auto" : "none"),
    marginLeft: 25,
    marginRight: 25,
    display: "flex",
  },
};
